import React, { FC } from 'react';
import { Card, Stack } from '@mui/material';
import { IService } from '../../../entity/IService';
import { useServiceCreating } from '../../../presenter/useServiceCreating';
import { ServiceControls } from '../serviceControls';
import { AutocompleteController } from '../../../../../../uiKit';
import { TextAutocomplete } from '../../../../../../uiKit/textAutocomplete';
import { CheckboxAutocompleteWithAll } from '../../../../../../uiKit/checkboxAutocompleteWithAll';
// import { CheckBoxAutocomplete } from '../../../../../../uiKit/checkBoxAutocomplete';


interface IProps {
    item?: IService;
    entityId: number;
    close: () => void;
    onUpdate?: () => Promise<void>;
}

export const ServiceCreatingView: FC<IProps> = ({ item, entityId, onUpdate, close }) => {
    const { loading, handleServiceChange, service, handleChangeClinics, clinics, serviceOptions, clinicOptions, onCreateService, errors, changeServiceText } = useServiceCreating(entityId, close, item, onUpdate);

    return (
        <Card sx={{ p: 2, mb: 2 }}>
            <Stack spacing={2} maxWidth="1200px">
                <TextAutocomplete title='Послуга' value={service} handleChangeValue={handleServiceChange} optionList={serviceOptions} error={errors.service} changeText={changeServiceText}/>
                {/* <CheckBoxAutocomplete label="Клініки" value={clinics} handleChange={handleChangeClinics} options={clinicOptions} isDisabled={!(!!service)}/> */}
                <CheckboxAutocompleteWithAll label='Клініки' value={clinics} handleChange={handleChangeClinics} options={clinicOptions} isDisabled={!(!!service)} error={errors.clinics}/>
                <ServiceControls onClose={close} onSave={onCreateService} isDisabledButton={loading} />
            </Stack>
        </Card>
    );
};
